@if (_document) {
  <div>
    <div>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary mb-2 me-2"
        (click)="addArticleLine()"
        [disabled]="isBusyAdding()"
      >
        {{ 'Doc::AddArticleLine' | abpLocalization }}
      </button>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary mb-2 me-2"
        (click)="addTextLine()"
        [disabled]="isBusyAdding()"
      >
        {{ 'Doc::AddTextLine' | abpLocalization }}
      </button>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary mb-2 me-2"
        (click)="addChapterLine()"
        [disabled]="isBusyAdding()"
      >
        {{ 'Doc::AddChapterLine' | abpLocalization }}
      </button>
    </div>
    <document-lines-editor
      #lineGrid
      [columnDefs]="columnDefs"
      [rows]="_document.lines"
      [getContextMenuItems]="getContextMenuItems"
      [onCellValueChanged]="onCellValueChanged"
      [onCellFocused]="onCellFocused"
      [onRowSelected]="onRowSelected"
      [treeData]="true"
      [getDataPath]="getDataPath"
      [textLineRole]="textLineRole"
      [chapterLineRole]="chapterLineRole"
      (onModelUpdated)="onModelUpdated($event)"
      [deleteActionEnabled]="deleteActionEnabled"
      [selectedLines]="selectedLines()"
      (deleteLines)="deleteLines()"
    ></document-lines-editor>
  </div>
}
